
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

//import {Echarts} from '../assets/lib/echarts.min.js'
let echarts = require('../assets/lib/echarts.min.js');
//import MyCell from "components/mycell"
export default {
    name: 'user',
    components: {
        Card,
        Divider,
        Group,
        Cell
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    },
    mounted() {
        console.log(this.$refs.mychart)
        var myChart = echarts.echarts.init(this.$refs.mychart);
        var option = {
            title: {
                show: false,
                text: '我的技能',
                left: 'center',
                textStyle: {
                    color: '#e683d1'
                }
            },
            legend: {
                show: false,
                data: ['黄彬'],
                // bottom: 5,
                // left: 'right',
                // itemGap: 20,
                // textStyle: {
                //     color: '#e683d1',
                //     fontSize: 14
                // },
                // selectedMode: 'single'
            },
            radar: {
                indicator: [{
                    name: 'vuejs',
                    max: 100
                }, {
                    name: 'jquery',
                    max: 100
                }, {
                    name: 'javascript',
                    max: 100
                }, {
                    name: 'React',
                    max: 100
                }, {
                    name: '微信小程序',
                    max: 100
                }, {
                    name: '整体',
                    max: 100
                }],
                radius: 90,
                shape: 'circle',
                splitNumber: 5,
                name: {
                    textStyle: {
                        color: "#ec6b83"
                    }
                },
                // splitLine: {
                //     lineStyle: {
                //         color: [
                //             'rgba(238, 197, 102, 0.1)', 'rgba(238, 197, 102, 0.2)',
                //             'rgba(238, 197, 102, 0.4)', 'rgba(238, 197, 102, 0.6)',
                //             'rgba(238, 197, 102, 0.8)', 'rgba(238, 197, 102, 1)'
                //         ].reverse()
                //     }
                // },
                splitArea: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(238, 197, 102, 0.5)'
                    }
                }
            },
            series: [{
                name: '黄彬',
                type: 'radar',
                lineStyle: {
                    normal: {
                        width: 1,
                        opacity: 0.5
                    }
                },
                data: [{
                    value: [80, 100, 95, 40, 50, 90],
                    name: '黄彬'
                }],
                symbol: 'none',
                itemStyle: {
                    normal: {
                        color: '#F9713C'
                    }
                },
                areaStyle: {
                    normal: {
                        opacity: 0.1
                    }
                }
            }]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
    },
    created: function() {
        //console.log(this.$el)
        console.log("created ")
        console.log(echarts.echarts)
    }
}



// WEBPACK FOOTER //
// ./src/components/user.vue